import { Box, Stack, Typography } from '@mui/material';

const TitleStackComponent = ({
  title = '',
  descriptions = '',
  subtitle = '',
  titleVariant = 'h4',
  stackGap = '1rem',
  showSetup = false
}) => {
  return (
    <Box>
      <Stack direction="row" sx={{ justifyContent: 'space-between' }}>
        <Stack
          gap={stackGap}
          sx={{ marginLeft: showSetup ? '0' : '-150px !important' }}
          style={{ display: 'flex', alignItems: 'center' }}>
          <Typography variant={titleVariant} style={{ fontSize: '24px' }}>
            {title}
          </Typography>
          {descriptions && (
            <Typography variant="body2" sx={{ color: 'text.secondary', wordBreak: 'break-word' }}>
              {descriptions}
            </Typography>
          )}
          {subtitle && (
            <Typography variant="body2" sx={{ color: 'text.secondary', wordBreak: 'break-word' }}>
              {subtitle}
            </Typography>
          )}
        </Stack>
      </Stack>
    </Box>
  );
};

export default TitleStackComponent;
